import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  latestSsePayload,
  getEventResultsSelector
} from '../../reducers/reigniteSseSlice'
import { useGetEventResultsQuery } from '../../api/resultsApi'
import { EventResultsComponent } from './EventResultsComponent'
import ReigniteServerSentEvents from '../../components/shared/ReigniteServerSentEvents'
import { ReigniteEventResultsProps, ReigniteSsePayload } from '../../utils/types'

export function ReigniteEventRbiResults(props: ReigniteEventResultsProps) {
  const ctliveEventId = props.master?.event?.ctliveId
  const ctliveRaceId = props.schedule?.find(schedule =>
    schedule.athlinksCourseId === props.races?.races?.find(
      race => race.eventCourseId === props.eventResultsFilters.course
    )?.courseId
  )?.raceId
  const athlinksEventId = props.eventResultsFilters.date
  const eventCourseId = props.eventResultsFilters.course
  const divisionId = props.eventResultsFilters.division
  const intervalId = props.eventResultsFilters.split
  const path = (ctliveEventId && ctliveRaceId && divisionId && intervalId
    ? `azp/ctlive/event/${ctliveEventId}/race/${ctliveRaceId}/bracket/${divisionId}/interval/${intervalId}`
    : '')
  const from = (props.page || props.eventResults.args.fro || 0) * props.eventResults.args.limit
  const limit = props.eventResults.args.limit
  const { data: eventResults, isFetching, refetch, isError } = useGetEventResultsQuery(
    {
      athlinksEventId,
      eventCourseId,
      divisionId,
      intervalId,
      from,
      limit,
    }
  )
  const sseState = useSelector(getEventResultsSelector(path))

  React.useEffect(() => {
    console.log('sseState', {
      ctliveEventId,
      ctliveRaceId,
      divisionId,
      intervalId,
      sseState,
    })
    if (sseState?.lastUpdated &&
      sseState.lastPayload?.type === 'results' && (
        !ctliveRaceId || ctliveRaceId === sseState.lastPayload.payload.raceId
      ) && (
        isNaN(divisionId) || divisionId === sseState.lastPayload.payload.bracketId
      ) && (
        isNaN(intervalId) || intervalId === sseState.lastPayload.payload.intervalId
      )
    ) {
      refetch()
    }
  }, [
    ctliveEventId,
    ctliveRaceId,
    divisionId,
    intervalId,
    refetch,
    sseState,
  ])
  const dispatch = useDispatch()

  const onMessage = React.useCallback(
    (data: ReigniteSsePayload) =>
      dispatch(
        latestSsePayload({
          path,
          ...data
        })
      ),
    [
      dispatch,
      path,
    ]
  )
  return (
    <>
      <ReigniteServerSentEvents onMessage={onMessage} path={path} />
      <EventResultsComponent
        {...props}
        fetchEventResultsError={isError}
        eventResults={{ data: eventResults || [] }}
        isFetchingEventResults={isFetching}
        refetch={refetch}
        useSse={true}
      />
    </>
  )
}
